export const actionsDefaultCrud = [
  { action: "view", enable: false, visibleInCrud: true },
  { action: "edit", enable: true, visibleInCrud: true },
  { action: "toggle", enable: true, visibleInCrud: true },
  { action: "delete", enable: true, visibleInCrud: true },
  { action: "create", enable: true },
];

const getQueryCode = (str) => {
  const code = str.split("/").pop();
  return code;
};

export const getQueryInfos = (url, profile) => {
  const code = getQueryCode(url);
  const query = profile.queries.find((q) => q.code === code);
  return query;
};

export const getDeepAttrValue = (_field, name, index=0) => {
  const attrs = name.split(".");
  const currentField = _field[attrs[index]];
  if(currentField){
    if(attrs.length > 1 && attrs.length-1 > index){
      return getDeepAttrValue(currentField, name, index+1);
    } else {
      return currentField;
    }
  }
}

export const getHostname = () => {
  const {protocol, hostname, pathname, port,search} = window.location;
  return {hostname, protocol, port, pathname, search};
}

// export const getFlagsExtracts = () => {
//   const options = [
//     { label: "Split", value: "split", chain:true, credit: false },
//     { label: "Crédito pré pago", value: "credit", chain:true, credit: false },
//     { label: "Consulta cobrada", value: "queryBilledPre", chain:true, credit: false },
//     { label: "Fatura Recebida", value: "invoiceReceived", chain:true, credit: false },

//     { label: "Consulta cobrada revenda", value: "queryBilledPosResale", chain:false, credit: true },
//     { label: "Consulta cobrada", value: "queryBilledPos", chain:false, credit: true },
//     { label: "Fatura Paga", value: "invoicePaied", chain:false, credit: true },
//   ]
// }

export function dataPorExtenso(city) {
    const hoje = new Date();

    const opcoes = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };

    // Formata a data para o português do Brasil
    const dataFormatada = hoje.toLocaleDateString('pt-BR', opcoes);

    // Capitaliza o mês apenas se necessário (opcional)
    return `${city}, ${dataFormatada}.`;
  }